import { render, staticRenderFns } from "./ComplainsBook.vue?vue&type=template&id=409c86c2&scoped=true"
import script from "./ComplainsBook.vue?vue&type=script&lang=js"
export * from "./ComplainsBook.vue?vue&type=script&lang=js"
import style0 from "./ComplainsBook.vue?vue&type=style&index=0&id=409c86c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409c86c2",
  null
  
)

export default component.exports